import { useEffect, useState, useRef } from 'react';
import axios from '../util/Axios';
import { 
  Grid, 
  Typography, 
  TableContainer, 
  Table, 
  TableHead, 
  TableBody, 
  TableRow, 
  TableCell, 
  IconButton, 
  Tooltip,
  Modal,
  Paper,
  Stack,
  Button
} from '@mui/material';
import RestoreIcon from '@mui/icons-material/RestoreFromTrash';
import CommentIcon from '@mui/icons-material/Comment';

function DeletedTests() {
  const [tests, setTests] = useState([]);
  const [openRestoreModal, setOpenRestoreModal] = useState(false);

  const restoreTestId = useRef(null);

  useEffect(() => {
    axios.get('/strokeTests/deleted')
      .then(response => {
        setTests(response.data);
      });
  }, []);

  const handleOpenRestoreModal = (testId) => {
    restoreTestId.current = testId;
    setOpenRestoreModal(true);
  };

  const handleCloseModal = () => {
    restoreTestId.current = null;
    setOpenRestoreModal(false);
  };

  const handleRestoreTest = () => {
    let testId = restoreTestId.current;

    axios.put(`/strokeTests/${testId}/restore`)
      .then(() => {
        let filteredTests = tests.filter(test => test.uuid !== testId)
        setTests(filteredTests);

        restoreTestId.current = null;
        setOpenRestoreModal(false);
      });
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography
            sx={{
              width: '100%',
              textAlign: 'center',
              marginTop: '16px',
              fontSize: '2em',
            }}
          >
            Deleted Tests
          </Typography>
        </Grid>
      </Grid>
      <TableContainer>
        <Table
          sx={{
            minWidth: 650,
          }}
          aria-label="simple table"
          size="small"
        >
          <TableHead>
            <TableRow>
              <TableCell>Test</TableCell>
              <TableCell>Doctor</TableCell>
              <TableCell>Patient</TableCell>
              <TableCell>Comment</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Delete reason</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tests.map((test) => (
              <TableRow key={test.uuid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell>{test.uuid}</TableCell>
                <TableCell>{test.doctor.name}</TableCell>
                <TableCell>{test.userId}</TableCell>
                <TableCell>
                {test.comment ? (
                    <Tooltip title={test.comment}>
                      <IconButton>
                        <CommentIcon></CommentIcon>
                      </IconButton>
                    </Tooltip>
                  ) : (
                    ''
                  )}
                </TableCell>
                <TableCell>{test.createdAt.split('.')[0].replace('T', ' ')}</TableCell>
                <TableCell>{test.deleteReason}</TableCell>
                <TableCell>
                  <IconButton variant="contained" onClick={() => handleOpenRestoreModal(test.uuid)}>
                    <RestoreIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      { openRestoreModal ?
        <Modal open={true} onClose={handleCloseModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Paper
            sx={{
              padding: '16px',
              position: 'absolute',
              minWidth: '550px',

              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography
              component="h3"
              sx={{
                fontSize: '1.5em',
                textAlign: 'center',
                marginBottom: '1em',
              }}
            >
              Are you sure you want to restore this test ?
            </Typography>
            <Stack direction="row" justifyContent="space-between">
              <Button onClick={handleCloseModal}>Cancel</Button>
              <Button 
                variant="contained" 
                onClick={handleRestoreTest}
              >
                Restore
              </Button>
            </Stack>
          </Paper>
        </Modal>
        :
        null
      }
    </>
  )
}

export default DeletedTests;